<template>
    <div>
        <h3>Come funziona</h3>
        <div v-html="notice"></div>
        
        <div class="d-flex flex-column gap-3 my-6">
            
            <button v-for="(subscription, i) in subscriptions"
                :key="i"
                class="btn btn-secondary d-flex align-items-center" 
                :class="{ 'active': subscription.id === activeSubscription }"
                @click="selectSubscription(subscription.id)">
                <span class="label" :class="{'unlimited' : isUnlimited(subscription.variations)}">
                    {{subscription.name}}
                </span>
                <span class="price ms-auto text-end" v-html="startPrice(subscription.variations)">
                </span>
            </button>
        </div>
        <div class="d-flex justify-content-center justify-content-md-start">
            <button 
                class="steplink stepnex btn btn-lg btn-primary"
                :disabled="canGoNext"
                @click="nextStep" 
                >Continua</button>
        </div>
    </div>
</template>

<script>
import {
    isEmpty,
    isNil
} from "lodash";


export default {
    name: 'DurationStep',
    data() {
        return {
            subscriptions: this.$store.state.subscriptions,
            desc: '',
            text: ''
        }
    },
    computed: {
        activeSubscription() {
            return this.$store.state.abbonamento.subscription;
        },
        canGoNext(){
            return !this.$store.state.abbonamento.subscription;
        },
        notice(){
            if(isNil(this.desc) || isEmpty(this.desc))
                return 'Seleziona per quanto tempo desideri ricevere i piatti in abbonamento';
            else
                return this.desc + this.text;
        }
    },
    mounted() {
        this.GTM_trackView("Step durata", "/abbonamento#step1");

        if(this.subscriptions.length > 0 && this.subscriptions.length < 2){
            setTimeout(() => {
                this.selectSubscription(this.subscriptions[0].id);
            }, 1000);
        }else if(this.subscriptions.length < 1){
            this.notice = 'Nessun abbonamento disponibile!';
        }
    },
    methods: {
        isUnlimited(variations) {
            return parseInt(variations[0].v_number) > 0 ? false : true;
        },
        startPrice(variations) {
            const lowestVariation = variations.reduce(
                (var1, var2) =>
                    parseFloat(var1.price) < parseFloat(var2.price)
                        ? var1
                        : var2
            );
            let result = 'Prezzo a partire da ';
            if ( !isEmpty(lowestVariation.sale_price) && lowestVariation.regular_price != lowestVariation.price )
                result += '<del>' + parseFloat(lowestVariation.regular_price) + '€</del> ' + parseFloat(lowestVariation.price) + '€/settimana ';
            else
                result += parseFloat(lowestVariation.regular_price) + '€/settimana ';

            if ( !isNil(lowestVariation.sale_price_from) && !isNil(lowestVariation.sale_price_to) ){
                const fromDate = new Date(lowestVariation.sale_price_from.date);
                const toDate = new Date(lowestVariation.sale_price_to.date);
                result += '<br><small>da ' + fromDate.getDate() + "/" + (fromDate.getMonth() + 1) + "/" + fromDate.getFullYear();
                result += ' a ' + toDate.getDate() + "/" + (toDate.getMonth() + 1) + "/" + toDate.getFullYear() + '</small>';
            }

            return result;
        },
        nextStep(){
            this.$emit("update", {
                next: true
            });
        },
        selectSubscription(id) {          
            let sub = this.subscriptions.filter(subscription => subscription.id == id);
            if(!isEmpty(sub)) {
                this.$store.commit("setStore", { subscription: id });
                this.$store.commit("setVariations", sub[0].variations);
                this.log(sub[0].desc);
                this.desc = sub[0].desc;
                this.text = sub[0].text;

                // this.log(id);
                // this.log(sub[0]);
                // this.log(sub[0].variations);
            }
        }
    }
}
</script>